
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire545f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire545f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$E = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$P(t, s);
        if (this.el = $e5ed8027d647799b$var$V.createElement(f, n), $e5ed8027d647799b$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$k : "?" === e[1] ? $e5ed8027d647799b$var$H : "@" === e[1] ? $e5ed8027d647799b$var$I : $e5ed8027d647799b$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$N(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$E.currentNode = e;
        let h = $e5ed8027d647799b$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$E.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$E.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$N(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$V.createElement($e5ed8027d647799b$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$V(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$M(this.S($e5ed8027d647799b$var$l()), this.S($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$N(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$N(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$k extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$N(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$N(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    P: $e5ed8027d647799b$var$e,
    A: $e5ed8027d647799b$var$h,
    C: $e5ed8027d647799b$var$o,
    M: 1,
    L: $e5ed8027d647799b$var$P,
    R: $e5ed8027d647799b$var$S,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$N,
    I: $e5ed8027d647799b$var$M,
    H: $e5ed8027d647799b$var$R,
    N: $e5ed8027d647799b$var$H,
    U: $e5ed8027d647799b$var$I,
    B: $e5ed8027d647799b$var$k,
    F: $e5ed8027d647799b$var$L
}, $e5ed8027d647799b$var$Z = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$Z?.($e5ed8027d647799b$var$V, $e5ed8027d647799b$var$M), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.1.4");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$M(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("bgeJJ", function(module, exports) {

var $jJTNo = parcelRequire("jJTNo");

var $9RWtd = parcelRequire("9RWtd");

var $jc90N = parcelRequire("jc90N");

var $aw8wR = parcelRequire("aw8wR");

var $lIyeL = parcelRequire("lIyeL");
class $e79202f3391f2c44$var$NavBar extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
    }
    get mainText() {
        return this.getAttribute("mainText");
    }
    set mainText(val) {
        this.setAttribute("mainText", val);
    }
    static get observedAttributes() {
        return [
            "mainText"
        ];
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.render();
        this.toggleSheetDropdown = this.toggleSheetDropdown.bind(this);
        this.toggleItemDropdown = this.toggleItemDropdown.bind(this);
        this.toggleVngrdDropdown = this.toggleVngrdDropdown.bind(this);
        this.toggleSheetMobileDropdown = this.toggleSheetMobileDropdown.bind(this);
        this.toggleItemMobileDropdown = this.toggleItemMobileDropdown.bind(this);
        this.toggleVngrdMobileDropdown = this.toggleVngrdMobileDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.toggleCloseMobileMenu = this.toggleCloseMobileMenu.bind(this);
        this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
        this.toggleMobileProfileMenu = this.toggleMobileProfileMenu.bind(this);
        const mediaQuery = window.matchMedia("(min-width: 1024px)");
        mediaQuery.addEventListener("change", (e)=>{
            if (e.matches) this.closeMobileMenu();
        });
        setTimeout(()=>{
            document.addEventListener("click", this.handleClickOutside);
            const elements = {
                "#sheets-button": this.toggleSheetDropdown,
                "#items-button": this.toggleItemDropdown,
                "#vngrd-button": this.toggleVngrdDropdown,
                "#sheets-mobile-button": this.toggleSheetMobileDropdown,
                "#item-mobile-button": this.toggleItemMobileDropdown,
                "#vngrd-mobile-button": this.toggleVngrdMobileDropdown,
                "#mobile-menu-button": this.toggleMobileMenu,
                "#close-menu-icon": this.toggleCloseMobileMenu,
                "#profile-button": this.toggleProfileMenu,
                "#mobile-profile-button": this.toggleMobileProfileMenu
            };
            Object.entries(elements).forEach(([selector, handler])=>{
                const element = this.shadow.querySelector(selector);
                if (element) element.addEventListener("click", handler);
            });
        }, 0);
    }
    toggleSheetDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#sheet-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleItemDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#item-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleVngrdDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#vngrd-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleSheetMobileDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#sheet-mobile-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleItemMobileDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#item-mobile-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleVngrdMobileDropdown(e) {
        e.stopPropagation();
        const dropdown = this.shadow.querySelector("#vngrd-mobile-dropdown");
        dropdown.classList.toggle("hidden");
    }
    toggleMobileMenu(e) {
        e.stopPropagation();
        const mobileMenu = this.shadow.querySelector("#mobile-menu");
        const overlay = document.createElement("div");
        overlay.className = "mobile-menu-overlay";
        const handleOutsideClick = (e)=>{
            if (!mobileMenu.contains(e.target)) {
                this.closeMobileMenu();
                document.removeEventListener("click", handleOutsideClick);
            }
        };
        if (mobileMenu.classList.contains("hidden")) {
            mobileMenu.classList.remove("hidden");
            this.shadow.appendChild(overlay);
            setTimeout(()=>{
                document.addEventListener("click", handleOutsideClick);
            }, 0);
        }
    }
    closeMobileMenu() {
        const mobileMenu = this.shadow.querySelector("#mobile-menu");
        const overlay = this.shadow.querySelector(".mobile-menu-overlay");
        mobileMenu.classList.add("hidden");
        if (overlay) overlay.remove();
    }
    toggleCloseMobileMenu(e) {
        e.stopPropagation();
        this.closeMobileMenu();
    }
    handleClickOutside(e) {
        const sheetDropdown = this.shadow.querySelector("#sheet-dropdown");
        const itemDropdown = this.shadow.querySelector("#item-dropdown");
        const vngrdDropdown = this.shadow.querySelector("#vngrd-dropdown");
        const profileMenu = this.shadow.querySelector("#profile-menu");
        const sheetDropdownButton = this.shadow.querySelector("#sheets-button");
        const itemDropdownButton = this.shadow.querySelector("#items-button");
        const vngrdDropdownButton = this.shadow.querySelector("#vngrd-button");
        const profileButton = this.shadow.querySelector("#profile-button");
        if (!sheetDropdown.contains(e.target) && !sheetDropdownButton.contains(e.target)) sheetDropdown.classList.add("hidden");
        if (!itemDropdown.contains(e.target) && !itemDropdownButton.contains(e.target)) itemDropdown.classList.add("hidden");
        if (!vngrdDropdown.contains(e.target) && !vngrdDropdownButton.contains(e.target)) vngrdDropdown.classList.add("hidden");
        if (!profileMenu.contains(e.target) && !profileButton.contains(e.target)) profileMenu.style.display = "none";
    }
    toggleProfileMenu(e) {
        e.stopPropagation();
        const menu = this.shadow.querySelector("#profile-menu");
        const isLoggedIn = menu.querySelector("#profileLink") && !menu.querySelector("#profileLink").classList.contains("hidden");
        if (isLoggedIn) menu.style.display = menu.style.display === "none" ? "block" : "none";
        else window.location.href = "/login";
    }
    toggleMobileProfileMenu(e) {
        e.stopPropagation();
        const menu = this.shadow.querySelector("#mobile-profile-menu");
        const isLoggedIn = menu.querySelector("#mobileProfileLink") && !menu.querySelector("#mobileProfileLink").classList.contains("hidden");
        if (isLoggedIn) menu.classList.toggle("hidden");
        else window.location.href = "/login";
    }
    async getSessionProfile() {
        try {
            const response = await fetch(`/user-profile`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data.isAuthenticated) {
                const loginText = data.displayName ? `Howdy, ${data.displayName}` : data.name ? `Howdy, ${data.name}` : "Howdy, Explorer";
                this.shadow.querySelector("#loginText").innerHTML = loginText;
                this.shadow.querySelector("#mobileLoginText").innerHTML = loginText;
                this.shadow.querySelector("#loginCaret").classList.remove("hidden");
                this.shadow.querySelector("#mobileLoginCaret").classList.remove("hidden");
                this.shadow.querySelector("#profileLink").classList.remove("hidden");
                this.shadow.querySelector("#logoutLink").classList.remove("hidden");
                this.shadow.querySelector("#mobileProfileLink").classList.remove("hidden");
                this.shadow.querySelector("#mobileLogoutLink").classList.remove("hidden");
                return true;
            } else {
                this.shadow.querySelector("#loginText").innerHTML = "Log in";
                this.shadow.querySelector("#mobileLoginText").innerHTML = "Log in";
                this.shadow.querySelector("#loginCaret").classList.add("hidden");
                this.shadow.querySelector("#mobileLoginCaret").classList.add("hidden");
                this.shadow.querySelector("#profileLink").classList.add("hidden");
                this.shadow.querySelector("#logoutLink").classList.add("hidden");
                this.shadow.querySelector("#mobileProfileLink").classList.add("hidden");
                this.shadow.querySelector("#mobileLogoutLink").classList.add("hidden");
                return false;
            }
        } catch (error) {
            console.error("Error:", error);
            return false;
        }
    }
    render() {
        const mainClass = "rounded-md bg-gray-900 px-3 py-2 text-sm font-medium cyan-text future-font";
        const nonMainClass = "rounded-md px-3 py-2 text-xs font-medium dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font";
        const sheetClass = this.mainText === "sheet" ? mainClass : nonMainClass;
        const vngrdClass = this.mainText === "vngrd" ? mainClass : nonMainClass;
        const itemClass = this.mainText === "item" ? mainClass : nonMainClass;
        const loginClass = this.mainText === "profile" ? mainClass : nonMainClass;
        const wikiClass = nonMainClass;
        const mainMobileClass = "block rounded-md bg-gray-900 px-3 py-2 text-base font-medium cyan-text future-font";
        const nonMainMobileClass = "block rounded-md px-3 py-2 text-base font-medium dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font";
        const sheetClassMobile = this.mainText === "sheet" ? mainMobileClass : nonMainMobileClass;
        const vngrdClassMobile = this.mainText === "vngrd" ? mainMobileClass : nonMainMobileClass;
        const itemClassMobile = this.mainText === "item" ? mainMobileClass : nonMainMobileClass;
        const loginClassMobile = this.mainText === "profile" ? mainMobileClass : nonMainMobileClass;
        const wikiClassMobile = nonMainMobileClass;
        const template = (0, $jJTNo.html)`
    <link
      href="https://fonts.googleapis.com/css2?family=Orbitron:wght@400;900&display=swap"
      rel="stylesheet"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Creepster&display=swap"
      rel="stylesheet"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap"
      rel="stylesheet"
    />
    <link href="${$9RWtd}" rel="stylesheet" />
    <link href="${$jc90N}" rel="stylesheet" />
    <link href="${$aw8wR}" rel="stylesheet" />
      <header class="bg-gray-800">
        <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
          <div class="flex lg:flex-1">
            <a href="/" class="-m-1.5 p-1.5">
              <span class="sr-only">Solaris</span>
              <img class="h-8 w-auto" src="${$lIyeL}" alt="">
            </a>
          </div>
          <div class="flex lg:hidden">
            <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 dark-cyan-text" id="mobile-menu-button">
              <span class="sr-only">Open main menu</span>
              <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" id="burger-menu-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            </button>
          </div>
          <div class="hidden lg:flex lg:gap-x-12">
            <div class="relative">
              <button type="button" class="flex items-center gap-x-1 text-sm/6 font-semibold ${sheetClass}" aria-expanded="false" id="sheets-button">
                Sheets
                <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                  <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </button>
              <div class="absolute top-full -left-8 highZ mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-gray-900 ring-1 shadow-lg ring-gray-900/5 lowerZ hidden" id="sheet-dropdown">
                <div class="p-4">
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/character-creator" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Standard Character Creator
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">The chracter sheet/ creator for the standard version of Solaris.</p>
                    </div>
                  </div>
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/ship-creator" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Ship Creator
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">The ship sheet/ creator for all versions of Solaris.</p>
                    </div>
                  </div>
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/call-of-the-horizon" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Call of the Horizon
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">The chracter sheet/ creator for the one-shot adventure supplement.</p>
                    </div>
                  </div>
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/grasp-of-the-void" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Grasp of the Void
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">The chracter sheet/ creator for the one-shot horror supplement.</p>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-600">
                  <a href="#" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm6.39-2.908a.75.75 0 0 1 .766.027l3.5 2.25a.75.75 0 0 1 0 1.262l-3.5 2.25A.75.75 0 0 1 8 12.25v-4.5a.75.75 0 0 1 .39-.658Z" clip-rule="evenodd" />
                    </svg>
                    Watch Tutorial (Coming Soon!)
                  </a>
                  <a href="https://patreon.com/discoversolaris" target="_blank" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                    </svg>
                    Become an Explorer
                  </a>
                </div>
              </div>
            </div>

            <div class="relative">
              <button type="button" class="flex items-center gap-x-1 text-sm/6 font-semibold ${itemClass}" aria-expanded="false" id="items-button">
                Tools
                <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                  <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </button>
              <div class="absolute top-full -left-8 highZ mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-gray-900 ring-1 shadow-lg ring-gray-900/5 lowerZ hidden" id="item-dropdown">
                <div class="p-4">
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="#" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Campaign Creator
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">Coming soon! A GMs toolbox for setting up and running a campaign within Solaris.</p>
                    </div>
                  </div>
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="#" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        GM Panel
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">Coming Soon! An all in one live view of all players and NPCs in a campaign.</p>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-600">
                  <a href="#" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm6.39-2.908a.75.75 0 0 1 .766.027l3.5 2.25a.75.75 0 0 1 0 1.262l-3.5 2.25A.75.75 0 0 1 8 12.25v-4.5a.75.75 0 0 1 .39-.658Z" clip-rule="evenodd" />
                    </svg>
                    Watch Tutorial (Coming Soon!)
                  </a>
                  <a href="https://patreon.com/discoversolaris" target="_blank" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                    </svg>
                    Become an Explorer
                  </a>
                </div>
              </div>
            </div>

            <div class="relative">
              <button type="button" class="flex items-center gap-x-1 text-sm/6 font-semibold ${vngrdClass}" aria-expanded="false" id="vngrd-button">
                Vanguard Commander
                <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                  <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
              </button>

              <div class="absolute top-full -left-8 highZ mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-gray-900 ring-1 shadow-lg ring-gray-900/5 lowerZ hidden" id="vngrd-dropdown">
                <div class="p-4">
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/vngrd-party" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Party Manager
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">Create and manage your party invites.</p>
                    </div>
                  </div>
                  <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-700">
                    <div class="flex-auto">
                      <a href="/vngrd-invite" class="block font-semibold dark-cyan-text hover:cyan-text future-font">
                        Join Party
                        <span class="absolute inset-0"></span>
                      </a>
                      <p class="mt-1 future-font dark-cyan-text">Use an invite code sent to you by a Vanguard Commander.</p>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-600">
                  <a href="#" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg class="size-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path fill-rule="evenodd" d="M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm6.39-2.908a.75.75 0 0 1 .766.027l3.5 2.25a.75.75 0 0 1 0 1.262l-3.5 2.25A.75.75 0 0 1 8 12.25v-4.5a.75.75 0 0 1 .39-.658Z" clip-rule="evenodd" />
                    </svg>
                    Watch Tutorial (Coming Soon!)
                  </a>
                  <a href="https://patreon.com/discoversolaris" target="_blank" class="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-100 hover:bg-gray-500 future-font">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                    </svg>
                    Become a Vanguard Commander
                  </a>
                </div>
              </div>
            </div>
            
            <a href="https://planetaria.wiki" target="_blank" class="text-sm/6 font-semibold ${wikiClass}">Wikiplanetaria</a>

          </div>
          <div class="hidden lg:flex lg:flex-1 lg:justify-end">
            <div class="relative">
              <button class="flex items-center gap-x-1 text-sm/6 font-semibold dark-cyan-text hover:cyan-text ${loginClass}" id="profile-button">
                <span id="loginText">Log in</span>
                <svg class="size-5 flex-none text-gray-400 hidden" id="loginCaret" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                  <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">User menu</span>
              </button>
              <div class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-gray-900 py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" id="profile-menu" style="display:none">
                <a href="/profile" class="block px-4 py-2 text-sm future-font hover:bg-gray-700 dark-cyan-text hover:cyan-text" id="profileLink">Profile</a>
                <a href="/logout" class="block px-4 py-2 text-sm future-font hover:bg-gray-700 dark-cyan-text hover:cyan-text" id="logoutLink">Logout</a>
              </div>
            </div>
          </div>
        </nav>
        
        <div class="lg:hidden highZ hidden" role="dialog" aria-modal="true" id="mobile-menu">
          <div class="fixed inset-0 highZ"></div>
          <div class="fixed inset-y-0 right-0 highZ w-full overflow-y-auto bg-gray-800 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div class="flex items-center justify-between">
              <a href="/" class="-m-1.5 p-1.5">
                <span class="sr-only">Solaris</span>
                <img class="h-8 w-auto" src="${$lIyeL}" alt="">
              </a>
              <button type="button" class="-m-2.5 rounded-md p-2.5 dark-cyan-text" id="close-menu-icon">
                <span class="sr-only">Close menu</span>
                <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="mt-6 flow-root">
              <div class="-my-6 divide-y divide-gray-500/10">
                <div class="space-y-2 py-6">
                  <div class="-mx-3">
                    <button type="button" class="flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold ${sheetClassMobile}" aria-controls="disclosure-1" aria-expanded="false" id="sheets-mobile-button">
                      Sheets
                      <svg class="size-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                    <div class="mt-2 space-y-2 hidden" id="sheet-mobile-dropdown">
                      <a href="/character-creator" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Standard Character Creator</a>
                      <a href="/ship-creator" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Ship Creator</a>
                      <a href="/call-of-the-horizon" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Call of the Horizon</a>
                      <a href="/grasp-of-the-void" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Grasp of the Void</a>
                    </div>
                  </div>

                  <div class="-mx-3">
                    <button type="button" class="flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold ${itemClassMobile}" aria-controls="disclosure-1" aria-expanded="false" id="item-mobile-button">
                      Tools
                      <svg class="size-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                    <div class="mt-2 space-y-2 hidden" id="item-mobile-dropdown">
                      <a href="#" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Campaign Creator (Coming Soon!)</a>
                      <a href="#" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">GM Panel (Coming Soon!)</a>
                    </div>
                  </div>
                  
                  <div class="-mx-3">
                    <button type="button" class="flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold ${vngrdClassMobile}" aria-controls="disclosure-2" aria-expanded="false" id="vngrd-mobile-button">
                      Vanguard Commander
                      <svg class="size-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                    <div class="mt-2 space-y-2 hidden" id="vngrd-mobile-dropdown">
                      <a href="/vngrd-party" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Party Manager</a>
                        <a href="/vngrd-invite" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font">Join Party</a>
                      </div>
                    </div>
                  </div>

                  <a href="https://planetaria.wiki" target="_blank" class="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold ${wikiClassMobile}">Wikiplanetaria</a>

                  <div class="-mx-3">
                    <button type="button" id="mobile-profile-button" class="flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold ${loginClassMobile}">
                      <span id="mobileLoginText">Log in</span>
                      <svg class="size-5 flex-none" id="mobileLoginCaret" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                    <div class="space-y-2 hidden" id="mobile-profile-menu">
                      <a href="/profile" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font" id="mobileProfileLink">Profile</a>
                      <a href="/logout" class="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold dark-cyan-text hover:bg-gray-700 hover:cyan-text future-font" id="mobileLogoutLink">Logout</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="glow-line"></div>
      </header>
    `;
        (0, $jJTNo.render)(template, this.shadow);
        this.getSessionProfile();
    }
}
customElements.define("nav-bar", $e79202f3391f2c44$var$NavBar);

});
parcelRegister("9RWtd", function(module, exports) {
module.exports = new URL("style.66dbc1da.css", import.meta.url).toString();

});

parcelRegister("jc90N", function(module, exports) {
module.exports = new URL("output.54132bce.css", import.meta.url).toString();

});

parcelRegister("aw8wR", function(module, exports) {
module.exports = new URL("brand.3bc21133.css", import.meta.url).toString();

});

parcelRegister("lIyeL", function(module, exports) {
module.exports = new URL("SOLARIS-01-LOGO.5bab14fa.png", import.meta.url).toString();

});


parcelRegister("l2CVb", function(module, exports) {

var $jJTNo = parcelRequire("jJTNo");

var $jc90N = parcelRequire("jc90N");

var $aw8wR = parcelRequire("aw8wR");
class $a1d1a27758b5ff9c$var$CustomFooter extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const template = (0, $jJTNo.html)`
      <link
        href="https://fonts.googleapis.com/css2?family=Orbitron:wght@400;900&display=swap"
        rel="stylesheet"
      />
      <link href="${$jc90N}" rel="stylesheet">
      <link href="${$aw8wR}" rel="stylesheet">
      <footer class="bg-gray-800">
        <div
          class="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8"
        >
          <div class="flex justify-center space-x-6 md:order-2">
            <a
              href="https://brainedge.llc"
              target="_blank"
              class="text-white hover:text-gray-400"
            >
              <span class="sr-only">Brain Edge</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/discoversolaris/"
              target="_blank"
              class="text-white hover:text-gray-400"
            >
              <span class="sr-only">Instagram</span>
              <svg
                class="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </div>
          <div class="mt-8 md:order-1 md:mt-0 future-font flex flex-wrap gap-4 justify-center">
            <a
              href="/privacy"
              class="text-white text-xs hover:text-gray-400 px-2"
            >
              Privacy
            </a>
            <a
              href="/cookies"
              class="text-white text-xs hover:text-gray-400 px-2"
            >
              Cookies
            </a>
            <a href="javascript:UC_UI.showSecondLayer();" id="usercentrics-psl" class="text-white text-xs hover:text-gray-400 px-2">
              Privacy Settings
            </a>
            <a
              href="/terms-of-service"
              class="text-white text-xs hover:text-gray-400 px-2"
            >
              Terms of Service
            </a>
            <a
              href="/disclaimer"
              class="text-white text-xs hover:text-gray-400 px-2"
            >
              Disclaimer
            </a>
          </div>
          <div class="mt-8 md:order-1 md:mt-0 future-font">
            <p class="text-center text-xs leading-5 text-white">
              &copy; 2025 Brain Edge, LLC. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    `;
        (0, $jJTNo.render)(template, this.shadow);
    }
}
customElements.define("custom-footer", $a1d1a27758b5ff9c$var$CustomFooter);

});

var $80ad20caa9ecbba0$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aKdi3","index.93956a0c.js","bFBXe","style.66dbc1da.css","hEH4t","output.54132bce.css","fLoJN","brand.3bc21133.css","7G6RH","SOLARIS-01-LOGO.5bab14fa.png"]'));


//# sourceMappingURL=index.93956a0c.js.map
